import { render, staticRenderFns } from "./LivenessAuth.vue?vue&type=template&id=a445c42e&scoped=true"
import script from "./LivenessAuth.vue?vue&type=script&lang=js"
export * from "./LivenessAuth.vue?vue&type=script&lang=js"
import style0 from "./LivenessAuth.vue?vue&type=style&index=0&id=a445c42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a445c42e",
  null
  
)

export default component.exports